import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { IonicModule } from '@ionic/angular/lazy';;

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  standalone: true,
  imports: [IonicModule]
})
export class NotFoundComponent {

  constructor(private router: Router) { }

  public goHome(): void {
    this.router.navigate(['/']);
  }

}
